import jwt_decode from "jwt-decode";

export default class User {
  static getToken = (): string => {
    return localStorage.getItem("authToken") ?? "";
  };

  static decodeToken = (): { [key: string]: string } => {
    return jwt_decode(this.getToken());
  };

  static getUserEmail = () => {
    return this.decodeToken().email ?? "";
  };
}
